/**
 *  @class
 *  @function ModalDialog
 */
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.age_verification = this.classList.contains('age-verification-modal');
      this.id = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.disabled = this.getAttribute('disabled') != undefined;
      this.button = this.querySelector('[id^="ModalClose-"]');

      this.button.addEventListener('click', this.hide.bind(this));

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            this.hide();
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
      if (this.delay && this.delay > 0) {
      if (!this.getCookie()) {
        // 6 Eki 2026 (Unimart): pop-up, çerez penceresi (#um-ck) kapandıktan sonra açılır ve her ziyaretçiye yalnız bir kez gösterilir
        const ckVisible = () => { const c = document.getElementById('um-ck'); if (!c) return false; const s = getComputedStyle(c); return s.display !== 'none' && s.visibility !== 'hidden' && c.getBoundingClientRect().height > 0; };
        let waited = false;
        const openWhenFree = () => {
          if (this.popup && ckVisible()) { waited = true; setTimeout(openWhenFree, 500); return; }
          if (waited) { waited = false; setTimeout(openWhenFree, 1500); return; }
          if (this.popup && this.getCookie()) return;
          this.show();
          if (this.popup) this.setCookie();
          this.button.addEventListener('click', this.setCookie.bind(this));
        };
        setTimeout(openWhenFree, this.delay);
      }
    }
    if (this.age_verification) {
        if (!this.getCookie()) {
          this.show();
        }
        this.button.addEventListener('click', this.setCookie.bind(this));
      }
      if (Shopify.designMode) {
        this.moved = true;
        this.onSectionSelectBound = (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.show();
          }
        };
        this.onSectionDeselectBound = (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.hide();
          }
        };
        document.addEventListener('shopify:section:select', this.onSectionSelectBound);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselectBound);
      }
    }

    disconnectedCallback() {
      if (this.onSectionSelectBound) {
        document.removeEventListener('shopify:section:select', this.onSectionSelectBound);
      }
      if (this.onSectionDeselectBound) {
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselectBound);
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      setTimeout(() => {
        this.querySelector('[role="dialog"]').focus();
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());

      if (this.popup) {

      }
    }

    getCookie() {
      return window.localStorage.getItem(this.id);
    }
    setCookie() {
      window.localStorage.setItem(this.id, JSON.stringify(new Date()));
    }
  }
  customElements.define('modal-dialog', ModalDialog);
}
if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
}